var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeDependentFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M21.189 8.659V4.672h-4.022 8.042"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 21.206,
    cy: 23.083,
    r: 13.644
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M22.161 24.808l-.04-8.792a7.096 7.096 0 11-7.203 3.785l7.243 5.007z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 32.622,
    cy: 9.397,
    r: 1.433
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeDependentFilled);
export default __webpack_public_path__ + "static/media/timeDependentFilled.bcb429127f073599bd0ab2f23df3abc1.svg";
export { ForwardRef as ReactComponent };